/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
 var str = window.location.href;
  if(!(str.indexOf('?variant=') + 1)) { 
  if( typeof(productOptions ) != "undefined" ){
    for(i=0;i<productOptions.length;i++) {

      var product_form__single_selector = document.querySelectorAll('.product-form__single-selector')[i];
      if(product_form__single_selector) {

        var option = document.createElement("option");
        option.value = "";
        option.text =  productOptions[i][i];
		option.disabled   = 'disabled';
        product_form__single_selector.prepend(option);
        product_form__single_selector.value = '';
        product_form__single_selector.dispatchEvent(new Event('change'));
        if(productOptions[0][0] != 'Title' ) {

          var addToCartButtonElement = document.querySelector('.product-form__payment-container .product-form__add-button');
          var infoListElement = document.querySelector('.product-form__info-list');
          addToCartButtonElement.setAttribute('disabled', 'disabled');
          addToCartButtonElement.classList.add('button--disabled');
          addToCartButtonElement.classList.remove('button--primary');
          addToCartButtonElement.removeAttribute('data-action');
          addToCartButtonElement.innerHTML = window.languages.productFormPick_an_option;
          infoListElement.style.display = 'none';
          product_form__single_selector.closest(".product-form__option").querySelector(".product-form__selected-value").innerHTML = "";
        }
      }
    }
  }
}
});